<template>
  <div class="container m-0 mt-lg-5 mb-4 d-flex flex-column gap-3">
    <div class="d-flex flex-column gap-3">
      <div class="d-flex flex-row">
        <div class="d-flex flex-row align-items-center justify-content-center gap-1">
          <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('volver') }}</span>
          </router-link>
          <p class="m-0 fs-5 texto-principal">{{ $t('volverAPersonas') }}</p>
        </div>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>


      <div class="d-flex flex-column flex-md-row justify-content-between gap-4 fondo-terciario rounded-4 p-4 pb-3 sombra-sm position-relative overflow-hidden">
        <div v-if="persona.FechaFallecimiento" class="position-absolute top-0 start-0 fondo-gris-oscuro fs-7 fw-bold p-1 px-2 rounded-bottom-end texto-principal-invertido"><p class="m-0">{{ $t('fallecido') }}</p></div>
        <div class="d-flex align-items-center gap-4 pb-2">
          <div class="d-flex align-items-center justify-content-start p-0 gap-2">
            <img v-if="persona.FotoUrl" :src="persona.FotoUrl" alt="Profile Picture" class="img-responsive" style="width: 120px; height: 120px; border-radius: 50%; object-fit: cover;" />
            <div v-else alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive pb-1 fondo-gris" style="width: 120px; height: 120px; border-radius: 50%; object-fit: cover; padding: 2px;" >
              <svg width="60" height="60" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Dribbble-Light-Preview" transform="translate(-140.000000, -2159.000000)" fill="#ffffff"><g id="icons" transform="translate(56.000000, 160.000000)"><path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598" id="profile_round-[#1342]"></path></g></g></svg>
            </div>
          </div>
          <div>
            <div class="d-flex flex-column flex-xl-row align-items-baseline gap-xl-3">
              <h1 class="fs-2 font-bold texto-principal m-0">{{ persona.Apellido + " " + persona.Nombre }}</h1>
              <p class="text-lg font-medium texto-secundario m-0">{{ persona.Cargo }}</p>
            </div>
            <div class="mt-2 d-flex flex-wrap gap-2">
              <!-- <div v-for="rol in persona.RolesVisuales" :key="rol.IdRol" class="d-flex align-items-center gap-2 rounded-pill px-2 py-1 fs-7"
                  :class="'fondo-'+rol.Estado.Color+'-2'">
                <span class="rounded-circle m-0 ms-1"  :class="'fondo-'+rol.Estado.Color+'-3'" style="height: 10px; width: 10px;"></span>
                
                <span class="m-0 me-1">{{ rol.Rol.Rol }}</span>
              </div> -->
              <div v-for="rol in persona.RolesVisuales" :key="rol.IdRol" class="item-pill rounded-pill px-2 py-1 fs-7 m-0 d-flex flex-inline align-items-center"
                  :class="'fondo-'+rol.Estado.Color+'-2'">
                <span class="rounded-circle m-0 mx-1 me-2"  :class="'fondo-'+rol.Estado.Color+'-3'" style="height: 10px; width: 10px;"></span>
                <!-- <span class="rounded-circle m-0 ms-1" style="background-color: rgba(0, 0, 0, 0.25); height: 10px; width: 10px;"></span> -->
                <!-- <span class="m-0 me-1">{{ rol.Rol.Rol }}</span> -->
                <p class="m-0 item-name">{{ $t(rol.Rol.Rol.toLowerCase() ?? "") }}</p>
                <!-- <span class="m-0 spacer">-</span> -->
                <p class="m-0 me-1 item-extra">&nbsp;- {{ $t(rol?.Estado?.Estado.toLowerCase() ?? "") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row flex-md-column flex-wrap justify-content-between" style="height: 100%;">
          <div class="d-flex flex-column gap-2 align-self-end" style="margin-bottom: 10px;">
            <a v-if="persona.FiduUserId" class="btn fidu-btn rounded-2 d-inline-flex align-items-center gap-1" :href="`https://app.fidu.la/perfiles/${persona.FiduUserId}`" target="_blank" rel="noopener noreferrer">
              <p class="m-0">{{ $t('perfilEn') }}</p>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="27" height="20" viewBox="0 0 88 42" fill="#f5f5f5" style="margin-bottom: 2px;">
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 13.53 3 27.06 3 41 C1.35 41 -0.3 41 -2 41 C-2.33 40.34 -2.66 39.68 -3 39 C-3.845625 39.495 -4.69125 39.99 -5.5625 40.5 C-9.92211262 42.40237642 -13.32689981 42.97554378 -17.89453125 41.30859375 C-21.01212995 39.73994935 -22.81639994 38.24282589 -24.9375 35.4375 C-26.81404644 29.36632036 -27.32491078 22.81342251 -24.375 17 C-21.71918539 13.64528681 -20.04476233 12.34825411 -16 11 C-10.7305664 10.43541783 -7.55215455 11.33532416 -3 14 C-2.95101562 13.15695312 -2.90203125 12.31390625 -2.8515625 11.4453125 C-2.77679688 10.34960938 -2.70203125 9.25390625 -2.625 8.125 C-2.55539063 7.03445312 -2.48578125 5.94390625 -2.4140625 4.8203125 C-2 2 -2 2 0 0 Z M-20 20 C-21.72869779 23.45739557 -21.48966895 27.21975568 -21 31 C-19.20606332 33.87029869 -18.01736724 35.49131638 -15 37 C-10.72865231 37.4835488 -8.70053885 37.48733137 -5.125 35 C-2.50430094 31.30018956 -1.68206825 28.51286462 -2 24 C-3.50282797 19.94236447 -4.38158741 18.41227506 -8 16 C-13.49264365 15.38970626 -16.0813844 16.0813844 -20 20 Z " transform="translate(55,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3.04898438 1.24136719 3.09796875 2.48273437 3.1484375 3.76171875 C3.22349799 5.40366694 3.29904439 7.04559297 3.375 8.6875 C3.4059375 9.50412109 3.436875 10.32074219 3.46875 11.16210938 C3.67710002 15.4506472 3.89040389 19.15264306 6 23 C8.84083641 24.42041821 10.85477278 24.31452272 14 24 C16.33796012 22.60909738 16.33796012 22.60909738 18 20 C18.58064793 16.96336826 18.60550299 13.96040243 18.625 10.875 C18.6504735 9.2472431 18.6839465 7.61958582 18.7265625 5.9921875 C18.73252441 5.27401855 18.73848633 4.55584961 18.74462891 3.81591797 C19 2 19 2 21 0 C21.99 0 22.98 0 24 0 C24 9.57 24 19.14 24 29 C22.35 29 20.7 29 19 29 C18.67 28.34 18.34 27.68 18 27 C17.360625 27.515625 16.72125 28.03125 16.0625 28.5625 C11.82559415 30.55125172 8.4352883 30.47039449 4 29 C0.9048729 26.55455759 -0.75103354 23.74689938 -2 20 C-2.12234153 17.15484822 -2.18512524 14.34496787 -2.1875 11.5 C-2.19974609 10.72785156 -2.21199219 9.95570312 -2.22460938 9.16015625 C-2.23476991 5.2517352 -2.21572048 3.32358072 0 0 Z " transform="translate(64,12)"/>
                <path d="M0 0 C0 1.65 0 3.3 0 5 C-1.98 5.33 -3.96 5.66 -6 6 C-6 7.98 -6 9.96 -6 12 C-4.02 12 -2.04 12 0 12 C0 13.32 0 14.64 0 16 C-1.98 16 -3.96 16 -6 16 C-6 24.25 -6 32.5 -6 41 C-7.98 41 -9.96 41 -12 41 C-12 32.75 -12 24.5 -12 16 C-13.32 16 -14.64 16 -16 16 C-15.67 14.68 -15.34 13.36 -15 12 C-14.01 12 -13.02 12 -12 12 C-11.938125 10.7625 -11.87625 9.525 -11.8125 8.25 C-11.390722 4.94607237 -11.10472781 4.11968892 -8.8125 1.5 C-5.59666415 -0.21511245 -3.59261138 -0.33419641 0 0 Z " transform="translate(16,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 9.57 3 19.14 3 29 C1.35 29 -0.3 29 -2 29 C-2.0578304 24.54172074 -2.09353855 20.0835372 -2.125 15.625 C-2.14175781 14.35398437 -2.15851562 13.08296875 -2.17578125 11.7734375 C-2.18222656 10.56171875 -2.18867188 9.35 -2.1953125 8.1015625 C-2.21102295 6.42054443 -2.21102295 6.42054443 -2.22705078 4.70556641 C-2 2 -2 2 0 0 Z " transform="translate(22,12)"/>
                <path d="M0 0 C1.65 0 3.3 0 5 0 C5.33 1.32 5.66 2.64 6 4 C4.125 5.0625 4.125 5.0625 2 6 C1.34 5.67 0.68 5.34 0 5 C0 3.35 0 1.7 0 0 Z " transform="translate(20,0)"/>
              </svg>
            </a>
            <!-- <button v-if="persona.FiduUserId" class="btn fidu-btn rounded-2 d-inline-flex align-items-center gap-1" type="button" disabled>
              <p class="m-0">{{ $t('actualizarEn') }}</p>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="27" height="20" viewBox="0 0 88 42" fill="#f5f5f5" style="margin-bottom: 2px;">
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 13.53 3 27.06 3 41 C1.35 41 -0.3 41 -2 41 C-2.33 40.34 -2.66 39.68 -3 39 C-3.845625 39.495 -4.69125 39.99 -5.5625 40.5 C-9.92211262 42.40237642 -13.32689981 42.97554378 -17.89453125 41.30859375 C-21.01212995 39.73994935 -22.81639994 38.24282589 -24.9375 35.4375 C-26.81404644 29.36632036 -27.32491078 22.81342251 -24.375 17 C-21.71918539 13.64528681 -20.04476233 12.34825411 -16 11 C-10.7305664 10.43541783 -7.55215455 11.33532416 -3 14 C-2.95101562 13.15695312 -2.90203125 12.31390625 -2.8515625 11.4453125 C-2.77679688 10.34960938 -2.70203125 9.25390625 -2.625 8.125 C-2.55539063 7.03445312 -2.48578125 5.94390625 -2.4140625 4.8203125 C-2 2 -2 2 0 0 Z M-20 20 C-21.72869779 23.45739557 -21.48966895 27.21975568 -21 31 C-19.20606332 33.87029869 -18.01736724 35.49131638 -15 37 C-10.72865231 37.4835488 -8.70053885 37.48733137 -5.125 35 C-2.50430094 31.30018956 -1.68206825 28.51286462 -2 24 C-3.50282797 19.94236447 -4.38158741 18.41227506 -8 16 C-13.49264365 15.38970626 -16.0813844 16.0813844 -20 20 Z " transform="translate(55,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3.04898438 1.24136719 3.09796875 2.48273437 3.1484375 3.76171875 C3.22349799 5.40366694 3.29904439 7.04559297 3.375 8.6875 C3.4059375 9.50412109 3.436875 10.32074219 3.46875 11.16210938 C3.67710002 15.4506472 3.89040389 19.15264306 6 23 C8.84083641 24.42041821 10.85477278 24.31452272 14 24 C16.33796012 22.60909738 16.33796012 22.60909738 18 20 C18.58064793 16.96336826 18.60550299 13.96040243 18.625 10.875 C18.6504735 9.2472431 18.6839465 7.61958582 18.7265625 5.9921875 C18.73252441 5.27401855 18.73848633 4.55584961 18.74462891 3.81591797 C19 2 19 2 21 0 C21.99 0 22.98 0 24 0 C24 9.57 24 19.14 24 29 C22.35 29 20.7 29 19 29 C18.67 28.34 18.34 27.68 18 27 C17.360625 27.515625 16.72125 28.03125 16.0625 28.5625 C11.82559415 30.55125172 8.4352883 30.47039449 4 29 C0.9048729 26.55455759 -0.75103354 23.74689938 -2 20 C-2.12234153 17.15484822 -2.18512524 14.34496787 -2.1875 11.5 C-2.19974609 10.72785156 -2.21199219 9.95570312 -2.22460938 9.16015625 C-2.23476991 5.2517352 -2.21572048 3.32358072 0 0 Z " transform="translate(64,12)"/>
                <path d="M0 0 C0 1.65 0 3.3 0 5 C-1.98 5.33 -3.96 5.66 -6 6 C-6 7.98 -6 9.96 -6 12 C-4.02 12 -2.04 12 0 12 C0 13.32 0 14.64 0 16 C-1.98 16 -3.96 16 -6 16 C-6 24.25 -6 32.5 -6 41 C-7.98 41 -9.96 41 -12 41 C-12 32.75 -12 24.5 -12 16 C-13.32 16 -14.64 16 -16 16 C-15.67 14.68 -15.34 13.36 -15 12 C-14.01 12 -13.02 12 -12 12 C-11.938125 10.7625 -11.87625 9.525 -11.8125 8.25 C-11.390722 4.94607237 -11.10472781 4.11968892 -8.8125 1.5 C-5.59666415 -0.21511245 -3.59261138 -0.33419641 0 0 Z " transform="translate(16,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 9.57 3 19.14 3 29 C1.35 29 -0.3 29 -2 29 C-2.0578304 24.54172074 -2.09353855 20.0835372 -2.125 15.625 C-2.14175781 14.35398437 -2.15851562 13.08296875 -2.17578125 11.7734375 C-2.18222656 10.56171875 -2.18867188 9.35 -2.1953125 8.1015625 C-2.21102295 6.42054443 -2.21102295 6.42054443 -2.22705078 4.70556641 C-2 2 -2 2 0 0 Z " transform="translate(22,12)"/>
                <path d="M0 0 C1.65 0 3.3 0 5 0 C5.33 1.32 5.66 2.64 6 4 C4.125 5.0625 4.125 5.0625 2 6 C1.34 5.67 0.68 5.34 0 5 C0 3.35 0 1.7 0 0 Z " transform="translate(20,0)"/>
              </svg>
            </button>
            <button v-else class="btn fidu-btn rounded-2 d-inline-flex align-items-center gap-1" type="button" disabled>
              <p class="m-0">{{ $t('subirA') }}</p>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="27" height="20" viewBox="0 0 88 42" fill="#f5f5f5" style="margin-bottom: 2px;">
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 13.53 3 27.06 3 41 C1.35 41 -0.3 41 -2 41 C-2.33 40.34 -2.66 39.68 -3 39 C-3.845625 39.495 -4.69125 39.99 -5.5625 40.5 C-9.92211262 42.40237642 -13.32689981 42.97554378 -17.89453125 41.30859375 C-21.01212995 39.73994935 -22.81639994 38.24282589 -24.9375 35.4375 C-26.81404644 29.36632036 -27.32491078 22.81342251 -24.375 17 C-21.71918539 13.64528681 -20.04476233 12.34825411 -16 11 C-10.7305664 10.43541783 -7.55215455 11.33532416 -3 14 C-2.95101562 13.15695312 -2.90203125 12.31390625 -2.8515625 11.4453125 C-2.77679688 10.34960938 -2.70203125 9.25390625 -2.625 8.125 C-2.55539063 7.03445312 -2.48578125 5.94390625 -2.4140625 4.8203125 C-2 2 -2 2 0 0 Z M-20 20 C-21.72869779 23.45739557 -21.48966895 27.21975568 -21 31 C-19.20606332 33.87029869 -18.01736724 35.49131638 -15 37 C-10.72865231 37.4835488 -8.70053885 37.48733137 -5.125 35 C-2.50430094 31.30018956 -1.68206825 28.51286462 -2 24 C-3.50282797 19.94236447 -4.38158741 18.41227506 -8 16 C-13.49264365 15.38970626 -16.0813844 16.0813844 -20 20 Z " transform="translate(55,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3.04898438 1.24136719 3.09796875 2.48273437 3.1484375 3.76171875 C3.22349799 5.40366694 3.29904439 7.04559297 3.375 8.6875 C3.4059375 9.50412109 3.436875 10.32074219 3.46875 11.16210938 C3.67710002 15.4506472 3.89040389 19.15264306 6 23 C8.84083641 24.42041821 10.85477278 24.31452272 14 24 C16.33796012 22.60909738 16.33796012 22.60909738 18 20 C18.58064793 16.96336826 18.60550299 13.96040243 18.625 10.875 C18.6504735 9.2472431 18.6839465 7.61958582 18.7265625 5.9921875 C18.73252441 5.27401855 18.73848633 4.55584961 18.74462891 3.81591797 C19 2 19 2 21 0 C21.99 0 22.98 0 24 0 C24 9.57 24 19.14 24 29 C22.35 29 20.7 29 19 29 C18.67 28.34 18.34 27.68 18 27 C17.360625 27.515625 16.72125 28.03125 16.0625 28.5625 C11.82559415 30.55125172 8.4352883 30.47039449 4 29 C0.9048729 26.55455759 -0.75103354 23.74689938 -2 20 C-2.12234153 17.15484822 -2.18512524 14.34496787 -2.1875 11.5 C-2.19974609 10.72785156 -2.21199219 9.95570312 -2.22460938 9.16015625 C-2.23476991 5.2517352 -2.21572048 3.32358072 0 0 Z " transform="translate(64,12)"/>
                <path d="M0 0 C0 1.65 0 3.3 0 5 C-1.98 5.33 -3.96 5.66 -6 6 C-6 7.98 -6 9.96 -6 12 C-4.02 12 -2.04 12 0 12 C0 13.32 0 14.64 0 16 C-1.98 16 -3.96 16 -6 16 C-6 24.25 -6 32.5 -6 41 C-7.98 41 -9.96 41 -12 41 C-12 32.75 -12 24.5 -12 16 C-13.32 16 -14.64 16 -16 16 C-15.67 14.68 -15.34 13.36 -15 12 C-14.01 12 -13.02 12 -12 12 C-11.938125 10.7625 -11.87625 9.525 -11.8125 8.25 C-11.390722 4.94607237 -11.10472781 4.11968892 -8.8125 1.5 C-5.59666415 -0.21511245 -3.59261138 -0.33419641 0 0 Z " transform="translate(16,0)"/>
                <path d="M0 0 C0.99 0 1.98 0 3 0 C3 9.57 3 19.14 3 29 C1.35 29 -0.3 29 -2 29 C-2.0578304 24.54172074 -2.09353855 20.0835372 -2.125 15.625 C-2.14175781 14.35398437 -2.15851562 13.08296875 -2.17578125 11.7734375 C-2.18222656 10.56171875 -2.18867188 9.35 -2.1953125 8.1015625 C-2.21102295 6.42054443 -2.21102295 6.42054443 -2.22705078 4.70556641 C-2 2 -2 2 0 0 Z " transform="translate(22,12)"/>
                <path d="M0 0 C1.65 0 3.3 0 5 0 C5.33 1.32 5.66 2.64 6 4 C4.125 5.0625 4.125 5.0625 2 6 C1.34 5.67 0.68 5.34 0 5 C0 3.35 0 1.7 0 0 Z " transform="translate(20,0)"/>
              </svg>
            </button> -->
          </div>

          <div class="d-flex justify-content-end">
            <p class="m-0 texto-secundario text-end fs-8">{{ $t('ultimaActualizacion') }}: {{ formattedUltimaActualizacion }}</p>
          </div>
        </div>
      </div>


      <!-- <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3" style="border-bottom: 2px solid var(--fondo-gris-claro); max-width: 100vw;"> -->
      <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3 fondo-terciario rounded-3 px-2 sombra-sm">
        <button
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 1}"
          @click="MenuVisible = 1"
        >
          {{ $t('datosPersonales') }}
        </button>
        <button v-if="asignarRoles || asignarPermisos"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 2}"
          @click="MenuVisible = 2"
        >
          <span v-if="asignarRoles">{{ $t('roles') }}</span>
          <span v-if="asignarRoles && asignarPermisos">{{ $t('y') }}</span>
          <span v-if="asignarPermisos">{{ $t('permisos') }}</span>
        </button>
        <button
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 3}"
          @click="MenuVisible = 3"
        >
          {{ $t('gruposYListas') }}
        </button>
        <button v-if="tieneAccesoTreffpunkt"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 4}"
          @click="MenuVisible = 4"
        >
          {{ $t('formularios') }}
        </button>
        <button v-if="tieneAsignaturas"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 5}"
          @click="MenuVisible = 5"
        >
          {{ $t('asignaturas') }}
        </button>
        <button v-if="hasVerHorariosPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 6}"
          @click="MenuVisible = 6"
        >
          {{ $t('horarios') }}
        </button>
        <div v-if="loadingMenu" class="loading-spinner h-100 d-inline-flex align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </div>
      </div>
    </div>
    <div>
      <!----------------Datos Personales------------------->
      <div v-if="MenuVisible == 1">
        <div class="row">
          <div class="col-lg-8">
            <!-- Informacion Personal -->
            <InfoPersonalSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" @updated="fetchPersona" />

            <!-- Informacion de Contacto -->
            <InfoContactoSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" @updated="fetchPersona" />

            <!-- Direcciones -->
            <DireccionesSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" @updated="fetchPersona" />
          </div>

          <div class="col-lg-4">
            <!-- Origen y Nacionalidad -->
            <OrigenYNacionalidadSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" @updated="fetchPersona" />
            
            <!-- Informacion Institucional -->
            <InfoInstitucionalSection v-if="isEmpleado || isProfesor || isPracticante || isPasante" :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" :tieneLegajo="isEmpleado || isProfesor" @updated="fetchPersona" />

            <!-- Contacto de emergencia -->
            <ContactoEmergSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="false" @updated="fetchPersona" />

            <IdsSection :persona="persona"/>
          </div>
        </div>
      </div>
      <!----------------Roles y Permisos------------------->
      <div v-if="MenuVisible == 2 && (asignarRoles || asignarPermisos)" class="d-flex flex-column flex-lg-row w-100 gap-3">
        <!----------------Roles------------------->
        <RolesSection v-if="asignarRoles" :persona="persona" :canAssignRoles="asignarRoles" :verRolesOcultos="verRolesOcultos" @updated="fetchPersona" />
        <!---------------Permisos----------------->
        <PermisosSection v-if="asignarPermisos" :persona="persona" @updated="fetchPersona" />
      </div>
      <!----------------Listas------------------->
      <ListasSection v-if="MenuVisible == 3" :persona="persona" :hasEditarListasPermission="hasEditarListasPermission" @updated="fetchPersona" />
      <!----------------Formularios------------------->
      <div v-if="MenuVisible == 4" class="d-flex flex-column gap-3">
        <div v-for="(form) in formularios" :key="form.IdFormulario" class="m-0 fs-7 w-100">
          <div class="d-flex flex-row gap-2 fondo-terciario sombra-sm rounded-4 align-items-center">
            <img v-if="form.PortadaUrl && !imagenError" :src="form.PortadaUrl" alt="Formulario" class="rounded-start-4"
              style="height: 80px; width: 120px; object-fit: cover; object-position: center;" @error="imagenError = true">
            <p class="m-0 fs-5 p-2 px-3">{{ form.NombreFormulario }}</p>
          </div>
        </div>
        <p v-if="!formularios || formularios.length == 0" class="m-0 fs-5 text-center">{{ $t('noHayForms') }}</p>
      </div>
      <!----------------Asignaturas------------------->
      <div v-if="MenuVisible == 5" class="d-flex flex-column gap-2">
        <div v-for="(asignatura) in asignaturas" :key="asignatura.IdAsignatura" class="m-0 fs-7 w-100">
          <div class="d-flex flex-row justify-content-between gap-2 fondo-terciario sombra-sm rounded-3 p-2 px-3">
            <p class="m-0 fs-6">{{ asignatura.NombreInterno }}</p>
            <p class="m-0 fs-6">{{ asignatura.Grupo.Nombre }}</p>
          </div>
        </div>
      </div>
      <!----------------Horarios------------------->
      <div v-if="MenuVisible == 6 && hasVerHorariosPermission && !loading && persona.IdPersona" class="d-flex flex-column w-100 gap-3">
        <HorariosSection v-if="esProfesor" :persona="persona" @updated="fetchPersona" />
        <HorariosBackOfficeSection :persona="persona" :esPerfilPropio="false" @updated="fetchPersona" />
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, computed, watch } from 'vue';
  import {useStore} from "vuex";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';
  import InfoPersonalSection from '@/components/PersonasTabs/DatosPersonales/InfoPersonalSection.vue';
  import InfoContactoSection from '@/components/PersonasTabs/DatosPersonales/InfoContactoSection.vue';
  import DireccionesSection from '@/components/PersonasTabs/DatosPersonales/DireccionesSection.vue';
  import OrigenYNacionalidadSection from '@/components/PersonasTabs/DatosPersonales/OrigenYNacionalidadSection.vue';
  import InfoInstitucionalSection from '@/components/PersonasTabs/DatosPersonales/InfoInstitucionalSection.vue';
  import ContactoEmergSection from '@/components/PersonasTabs/DatosPersonales/ContactoEmergSection.vue';
  import RolesSection from '@/components/PersonasTabs/RolesSection.vue';
  import PermisosSection from '@/components/PersonasTabs/PermisosSection.vue';
  import ListasSection from '@/components/PersonasTabs/ListasSection.vue';
  import IdsSection from '@/components/PersonasTabs/DatosPersonales/IdsSection.vue';
  import HorariosSection from '@/components/PersonasTabs/HorariosSection.vue';
  import HorariosBackOfficeSection from '@/components/PersonasTabs/HorariosBackOfficeSection.vue';

export default {
   name: 'VerDatosPersonas',
   components: {
     InfoPersonalSection,
     InfoContactoSection,
     DireccionesSection,
     OrigenYNacionalidadSection,
     InfoInstitucionalSection,
     ContactoEmergSection,
     RolesSection,
     PermisosSection,
     ListasSection,
     IdsSection,
     HorariosSection,
     HorariosBackOfficeSection,
   },
   setup() {
    const { t } = useI18n();
    var loading = ref(false);
    var loadingMenu = ref(false);
    var asignarPermisos = ref(false);
    var asignarRoles = ref(false);
    var verRolesOcultos = ref(false);
    var hasEditarPersonaPermission = ref(false);
    var hasEditarListasPermission = ref(false);
    var hasVerHorariosPermission = ref(false);
    var tieneAccesoTreffpunkt = ref(false);
    var tieneAsignaturas = ref(false);
    const MenuVisible = ref(1);
    const store = useStore();
    const user = computed(() => store.state.user);
    const persona = ref({});
    const formularios = ref([]);
    const asignaturas = ref([]);
    const imagenError = ref(false);

    const esProfesor = computed(() => {
      const roles = persona.value.PersonasRoles;
      if (!roles || !Array.isArray(roles)) return false;
      return roles.some(pr => pr.Rol && pr.Rol.Rol === 'Profesor');
    });

    const checkAuth = async  () => {
      var permisoAComprobar = 'AsignarPermisos'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        asignarPermisos.value = true;
      }
      permisoAComprobar = 'AsignarRoles'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        asignarRoles.value = true;
      }
      permisoAComprobar = 'VerRolesOcultos'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        verRolesOcultos.value = true;
      }
      permisoAComprobar = 'EditarPersonas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasEditarPersonaPermission.value = true;
      }
      permisoAComprobar = 'EditarListas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasEditarListasPermission.value = true;
      }
      permisoAComprobar = 'VerHorarios'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasVerHorariosPermission.value = true;
      }
    };

    const fetchPersona = async () => {
      try {
        loading.value = true;
        const idUser = localStorage.getItem('id');
        const response = await api.get(`api/Persona/`+ idUser);
        //console.log(response.data)
        persona.value = response.data;

        // Get latest roles by grouping and taking the most recent FechaHora
        let latestRoles = {};
        persona.value.HistorialRoles?.forEach(hr => {
          const roleId = hr.Rol.IdRol;
          if (!latestRoles[roleId] || new Date(hr.FechaHora) > new Date(latestRoles[roleId].FechaHora)) {
            latestRoles[roleId] = hr;
          }
        });
        let rolesArray = Object.values(latestRoles);

        if(!verRolesOcultos.value){
          persona.value.RolesVisuales = rolesArray.filter(pr => !pr.Rol?.Oculto).sort((a, b) => a.Rol.Rol.localeCompare(b.Rol.Rol))
        }else{
          persona.value.RolesVisuales = rolesArray.sort((a, b) => a.Rol.Rol.localeCompare(b.Rol.Rol))
        }

        // Se guarda el legajoId del rol de un empleado
        const specificRole = persona.value.PersonasRoles?.find(pr => pr.IdRol === '2bef46cb-2393-4626-ab12-55f7c48377d2');
        const specificRoleHistorial = persona.value.RolesVisuales?.find(pr => pr.IdRol === '2bef46cb-2393-4626-ab12-55f7c48377d2');
        persona.value.LegajoIdEmpleado = specificRole
            ? specificRole.LegajoId // 1. Si specificRole existe, usa su LegajoId
            : specificRoleHistorial // 2. Si specificRole NO existe, verifica specificRoleHistorial
              ? specificRoleHistorial.LegajoId // 3. Si specificRoleHistorial existe, usa su LegajoId
              : null; // 4. Si ninguno de los dos existe, asigna null

        var permisoAComprobar = 'AccesoTreffpunkt'
        if (persona.value.PersonasPermisos?.some(persPermiso => persPermiso.Permiso?.permiso === permisoAComprobar) || 
          persona.value.PersonasRoles?.some(persRoles => persRoles.Rol?.Permisos?.some(p => p.permiso === permisoAComprobar)))
        {
          tieneAccesoTreffpunkt.value = true;
        }

        console.log(persona.value)
        fetchFormularios();
        fetchAsignaturas();
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    
    const isEmpleado = computed(() => {
      const empRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'empleado');
      return empRole ? true : false;
    });

    const isProfesor = computed(() => {
      const profRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'profesor');
      return profRole ? true : false;
    });

    const isComisionDirectiva = computed(() => {
      const profRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'comision directiva');
      return profRole ? true : false;
    });

    const isPasante = computed(() => {
      const profRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'pasante');
      return profRole ? true : false;
    });

    const isPracticante = computed(() => {
      const profRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'practicante');
      return profRole ? true : false;
    });

    const isAlumno = computed(() => {
      const aluRole = persona.value?.PersonasRoles?.find(r => r.Rol?.Rol.toLowerCase() === 'alumno');
      return aluRole ? true : false;
    });
    
    
    const fetchFormularios = async () => {
      try {
        const response = await api.get(`api/Formularios/ByIdPersona`, {
          params: {
            id: persona.value.IdPersona
          },
        });
        
        formularios.value = response.data
        //console.log(formularios.value)
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };


    const fetchAsignaturas = async () => {
      try {
        loadingMenu.value = true;
        const response = await api.get(`api/Asignaturas/ByIdProfesor`, {
          params: {
            id: persona.value.IdPersona
          },
        });
        asignaturas.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        if(asignaturas.value!= null && asignaturas.value.length>0){
          tieneAsignaturas.value = true;
        }
        //console.log(asignaturas.value)
        loadingMenu.value = false;
      } catch (error) {
        loadingMenu.value = false;
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const formattedUltimaActualizacion = computed(() => {
      if (!persona.value.UltimaActualizacion) return 'N/A';
      const date = new Date(persona.value.UltimaActualizacion);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    });

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      // Load saved menu preference
      const savedMenu = localStorage.getItem('verDatosPersonaMenuVisible');
      if (savedMenu) {
        MenuVisible.value = parseInt(savedMenu);
      }
      checkAuth();
      fetchPersona();
    });

    // Watch for changes in MenuVisible and save to localStorage
    watch(MenuVisible, (newVal) => {
      localStorage.setItem('verDatosPersonaMenuVisible', newVal.toString());
    });

    return {
      t,
      persona,
      loading,
      loadingMenu,
      asignarRoles,
      asignarPermisos,
      MenuVisible,
      asignaturas,
      tieneAsignaturas,
      hasEditarPersonaPermission,
      hasEditarListasPermission,
      hasVerHorariosPermission,
      formularios,
      formattedUltimaActualizacion,
      fetchPersona,
      verRolesOcultos,
      imagenError,
      esProfesor,
      tieneAccesoTreffpunkt,
      isEmpleado,
      isProfesor,
      isAlumno,
      isComisionDirectiva,
      isPasante,
      isPracticante,
    };
  },
};
</script>

<style>
</style>